const ID_KEY = 'savedUserId'
const TEL_KEY = 'savedSpTelNo'

export const getUserSavedId = () => {
  return window.localStorage.getItem(ID_KEY)
}

export const saveUserId = userId => {
  window.localStorage.setItem(ID_KEY, userId)
}

export const destroyUserId = () => {
  window.localStorage.removeItem(ID_KEY)
}

export const getUserSavedSpTelNo = () => {
  return window.localStorage.getItem(TEL_KEY)
}

export const saveUserSpTelNo = spTelNo => {
  window.localStorage.setItem(TEL_KEY, spTelNo)
}

export const destroyUserSpTelNo = () => {
  window.localStorage.removeItem(TEL_KEY)
}

export default { getUserSavedId, saveUserId, destroyUserId, getUserSavedSpTelNo, saveUserSpTelNo, destroyUserSpTelNo }
